import {create} from 'zustand';

import {middleware} from 'store/zustand';

import {produce} from 'immer';

export const usePairingStore = create(middleware((set, _get) => ({
    activePairing: {},
    set: p => set(produce(draft => {
        console.log('[PairingStore] Setting activePairing:', p);
        draft.activePairing = p;
    })),
    unset: () => set(produce(draft => {
        console.log('[PairingStore] Unsetting activePairing');
        draft.activePairing = {};
    })),
}), {name: 'PairingStore', debug: true}));